import React, { useEffect } from 'react';
import { Link, Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import urljoin from 'url-join';

import Paper from '~/components/core/Atomic/Paper';
import { Tab, Tabs } from '~/components/core/Atomic/Tabs';
import ContactFinanceVerificationApprovals from '~/components/Finances/FinanceApprovalsTab/ContactFinanceVerificationApprovals';
import ContactTfnVerificationApprovals from '~/components/Finances/FinanceApprovalsTab/ContactTfnVerificationApprovals';
import ReserveChangeRequestApprovals from '~/components/Finances/FinanceApprovalsTab/ReserveChangeRequestApprovals/ReserveChangeRequestApprovals';
import { usePaymentsConfiguration } from '~/components/hooks/usePaymentsConfiguration';

import { useCms } from '../../hooks/useCms';

import PaymentApprovals from './PaymentApprovals';
import PaymentSubmissions from './PaymentSubmissions';

import { useStyles } from '../../../assets/styles';

const FinanceApprovalTab = () => {
  const { classes } = useStyles();
  const { setPageTitle } = useCms();
  const match = useRouteMatch();
  const location = useLocation();
  const {
    isApprovalPaymentsScreenEnabled,
    isPaymentsSubmissionScreenEnabled,
    isContactFinanceApprovalTabEnabled,
    isContactTfnApprovalTabEnabled,
  } = usePaymentsConfiguration();

  const possibleTabs = [
    {
      label: 'Payment Approvals',
      url: 'payment_approvals',
      component: PaymentApprovals,
      conditionFunc: () => isApprovalPaymentsScreenEnabled,
    },
    {
      label: 'Reserve Approvals',
      url: 'reserve_approvals',
      component: ReserveChangeRequestApprovals,
      conditionFunc: () => isApprovalPaymentsScreenEnabled,
    },
    {
      label: 'Payment Submissions',
      url: 'payment_submissions',
      component: PaymentSubmissions,
      conditionFunc: () => isPaymentsSubmissionScreenEnabled,
    },
    {
      label: 'Contact Finance',
      url: 'contact_finance_verifications',
      component: ContactFinanceVerificationApprovals,
      conditionFunc: () => isContactFinanceApprovalTabEnabled,
    },
    {
      label: 'Contact TFN',
      url: 'contact_tfn_verifications',
      component: ContactTfnVerificationApprovals,
      conditionFunc: () => isContactTfnApprovalTabEnabled,
    },
  ];

  const tabs = possibleTabs.filter((tab) => (tab.conditionFunc ? tab.conditionFunc() : true));

  const path = location.pathname.substring(match.url.length + 1);
  const breadcrumbs = path.split('/');
  let currTabValue = tabs.findIndex((tab) => breadcrumbs.includes(tab.url));
  currTabValue = currTabValue >= 0 ? currTabValue : 0;

  useEffect(() => {
    setPageTitle('Approvals', 'Approvals - Five Sigma CMS');
  }, [setPageTitle]);

  return (
    <>
      <div>
        <Paper className="bg-slate-200">
          <Tabs value={currTabValue} style={{ minHeight: 40 }} variant="scrollable" textColor="inherit">
            {tabs.map((tab) => (
              <Tab
                style={{
                  minHeight: 40,
                  // v4 added this inset via the Tab's inner wrapper span, which v5 deleted; the theme's
                  // folded root padding cannot reach it through an inline style, so carry it here.
                  padding: '10px 35px',
                }}
                key={tab.url}
                label={tab.label}
                component={Link}
                to={`${match.url}/${tab.url}`}
              />
            ))}
          </Tabs>
        </Paper>
      </div>
      <div className={classes.pageBody}>
        <Switch>
          <Redirect exact from={`${match.path}/`} to={urljoin(match.path, tabs[0].url)} />
          {tabs.map((tab) => (
            <Route key={tab.url} path={urljoin(match.path, tab.url)} render={() => <tab.component />} />
          ))}
          <Redirect to={match.path} />
        </Switch>
      </div>
    </>
  );
};

export default FinanceApprovalTab;
